module.exports = __webpack_public_path__ + "static/media/notification-02.33f9a452.m4a";